import React, {useEffect, useState} from 'react';
import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import _ from 'lodash';
import { FormPageFieldComponentDefaultProps } from 'types/formPage';
import {v4 as uuid} from 'uuid';
import {_isBlank, extract, fieldValAsString, toChip, wrapArray, wrapComponent} from "../utils";
import {useField, useFormikContext} from "formik";
import {InputTextProps} from "primereact/inputtext";
import {Dropdown, DropdownProps} from "primereact/dropdown";
import {ListBox, ListBoxProps} from "primereact/listbox";
import {RadioButton, RadioButtonProps} from "primereact/radiobutton";
import {SelectButton, SelectButtonProps} from "primereact/selectbutton";
import {AutoComplete, AutoCompleteProps } from 'primereact/autocomplete';
import { Checkbox, CheckboxProps } from 'primereact/checkbox';
import PickList from "./PickList";
import InplaceCustomOption from "./InplaceCustomOption";

type BaseSelectProps = (AutoCompleteProps | SelectButtonProps | CheckboxProps | RadioButtonProps | DropdownProps | ListBoxProps | InputTextProps | MultiSelectProps) & FormPageFieldComponentDefaultProps
& {
  compOnly?: boolean;
  records?: any[]|null
  getRecord?: (id:any, supplied?:any[]) => any
}
export const BaseSelect = ({ value, multiple, compOnly = false, records = null, getRecord = null, extraConfig = {}, disabled, ...restProps }: BaseSelectProps) => {

  const {enabled_parent_mapping,parent_mapping, parent_field_id, disable_if_empty, parent_no_match_action, case_sensitive_matching, allow_partial_match, options : optionsExtra = {}} = extraConfig
  const {values, setFieldValue} = useFormikContext()
  const parent_value = parent_mapping && parent_field_id ? _.get(values, parent_field_id) : null
  disabled = disabled || (enabled_parent_mapping && disable_if_empty && _isBlank(parent_value))


  const doMatch = (val, items, asArray = false) => {
    const matches = items.filter( pc => !!wrapArray(val).find( p => [pc.id, pc.name].includes(_.isObject(p as any) ? p.id || p.name : p) ) )
    return asArray || Array.isArray(val) ? matches : matches.shift()
  }
  const checkParentValue = (parentValue, parentMatch, parentChoices = null) => {
    if (_isBlank(parentMatch)) return false;
    if (Array.isArray(parentValue)) {
      return parentValue.filter(pv => checkParentValue(pv,parentMatch, parentChoices)).length > 0
    } else {

      let useParent = Array.isArray(parentChoices) ? doMatch(parentValue,parentChoices) : parentValue
      let useParentMatch = Array.isArray(parentChoices) ? doMatch(parentMatch,parentChoices) : parentMatch
      console.log('[PARENT MATCH]', {useParent, useParentMatch, parentValue, parentMatch,parentChoices})
      if(Array.isArray(useParent)){
        if(!case_sensitive_matching){
          const doMap =  up => _.isObject( up as any ) ? ({...up, id: up.id?.toUpperCase(), name: up.name?.toUpperCase()} ) : up?.toUpperCase()
          useParent = useParent.map( doMap )
          useParentMatch = Array.isArray(useParentMatch) ? useParentMatch.map( doMap ) : _.toUpper(useParentMatch)
        }
        const matched = doMatch( useParentMatch, useParent, true)
        return allow_partial_match ? matched.length > 0 : matched.length === useParent.length
      }else{
        const toVal = val => _.isObject(val as any) ? val.name : val || ''
        useParent = toVal(useParent)
        useParentMatch = toVal(useParentMatch)
        if(!case_sensitive_matching){
          useParent = _.toUpper(useParent)
          useParentMatch = _.toUpper(useParentMatch)
        }
        return allow_partial_match ? `${useParentMatch ||''}`.indexOf(`${useParent || ''}`) > -1 : useParent === useParentMatch
      }

    }
  }


  useEffect( () => {
    if (enabled_parent_mapping) {
        const allFields = _.get(restProps, 'details.fields') || []
        const parentField = allFields.find( af => af.id === parent_field_id)
        const parentFieldChoices = _.get(parentField, 'options.choices')
        const matchedValues = parent_mapping && parent_mapping.mappings.filter(f => checkParentValue( parent_value, f.parent, parentFieldChoices));
        console.log('[PARENT MAP]', { parentField, parentFieldChoices, matchedValues, parent_mapping, parent_value})
        let newOptions = []
        if (matchedValues?.length > 0) {
          const nChoices = _.uniqBy( matchedValues.reduce((newChoices, matchedValue) => {
            return newChoices.concat( (optionsExtra?.choices || []).filter(f => wrapArray(matchedValue.children).includes(f.id)) )
            // optionsExtra?.choices.filter(f => wrapArray(matchedValue.children).includes(f.id)).forEach((fValue) => {
            //   if (newChoices.length === 0 || newChoices.filter(f => f.id === fValue.id).length === 0) {
            //     newChoices.push(fValue)
            //   }
            // })
            // return newChoices;
          }, []), 'id' )
          newOptions = processOptions(nChoices, !(nChoices.length === (optionsExtra?.choices || []).length))
          setOptions(newOptions)
        } else {
          newOptions = processOptions(parent_no_match_action === "display_all" ? (optionsExtra?.choices || []) : [], true)
          setOptions(newOptions)
        }
        let newValue = doMatch( field.value, newOptions, true ).map( em => em[primaryValueKey] )
        if(!multiple)newValue = newValue.shift()
        console.log('[After Changing]', {field:field.value, options,newOptions, newValue})
        if(!_.isEqual(field.value, newValue ) ){
          setFieldValue(field.name, newValue)
        }
        // if (options.filter(f => f.name === field.value).length === 0) field.value = "";
    }else {
      setOptions(optionsExtra?.choices || [])
    }

  }, [parent_value, optionsExtra?.choices])




  const isRecordMode = !!records
  const DO_FILTER_MODES = ['autocomplete']
  const { display_as = multiple ? 'multiselect' : 'dropdown', as_chip = true, allow_create = false, create_label = '', use_color = !isRecordMode, options:initOptions = {} } = extraConfig;
  const { choices = [] } = initOptions || {}
  if(!restProps.placeholder)restProps.placeholder = 'Select...'
  const [customOptions, setCustomOptions] = useState([] as any[])
  const [field, meta, helpers] = useField(restProps.name);

  const [filter, setFilter] = useState('')
  const [options, setOptions] = useState([])
  console.log('[BaseSelect]', {value, records, display_as, multiple,extraConfig, restProps})
  const onFilterChange = ({value:lbFilter, filter:ddFilter}:any) => {
    const newFilter = lbFilter || ddFilter
    setFilter(newFilter)

  }
  const onAutoComplete = (event) => {
      setFilter( event.query )
  }

  const determinePrimaryLabelKey = () => {
    if(isRecordMode){
      return _.get(extraConfig,'display_field.name', 'Name')
    }else{
      return _.get(extraConfig, 'keyLabel', 'name')
    }
  }
  const determinePrimaryValueKey = () => {
    if(isRecordMode){
      return 'tableRecordId'
    }else{
      return _.get(extraConfig, 'keyValue', 'name')//use name for value on select fields
    }
  }

  const primaryLabelKey = determinePrimaryLabelKey()
  const primaryValueKey = determinePrimaryValueKey()
  const valueIndexOf = (val) => _.findIndex( wrapArray(field.value), fv => ( _.isObject(fv) ? fv[primaryValueKey] : fv ) === ( _.isObject(val) ? val[primaryValueKey] : val ) )
  const onRemoveVal = (key) => {
    if(Array.isArray(field.value) ){
      const newVal = [...field.value]
      const index = valueIndexOf(key)
      if(index >=0)newVal.splice(index, 1)
      helpers.setValue( newVal )
    }else{
      helpers.setValue( null )
    }

  }
  const optionDef = (loc) => ({value: primaryValueKey, label: primaryLabelKey, onRemove: loc === 'value' && ['multiselect'].includes(display_as) ? onRemoveVal : null})

  const updateCustomOptions = ( addNewOption = '', addToSelected = true) => {
    const newOptions = [...customOptions]
    if(addNewOption){
      const newOption = {[primaryValueKey]: uuid(), [primaryLabelKey]: addNewOption}
      newOptions.push(newOption)
      if(addToSelected){
        helpers.setValue( _.isArray(field.value) ? field.value.concat([addNewOption]) : ( multiple ? [addNewOption] : addNewOption ) )
      }
    }
    setCustomOptions(newOptions)

  }
  const toVal = () => {
    const val = wrapArray(field.value).map( v => _.isObject(v) ? v[primaryValueKey] : v)
    return multiple ? val : val.shift()
  }
  const choiceLabel= (choice) => choice ? (_.isObject( choice ) ? choice[primaryLabelKey] : (choices.find( c => c[primaryValueKey] === choice) || {[primaryLabelKey]: choice})[primaryLabelKey] ) : <p></p>
  const choiceVal = (choice) => choice ? choice[primaryValueKey] : null
  const choiceHas = (choice) => isRecordMode ? !!wrapArray(field.value).find( v => fieldValAsString(_.isObject(v) ? v[primaryValueKey] : v) === fieldValAsString(choice[primaryValueKey]) ) : wrapArray(field.value ?? (_.isBoolean(choice[primaryValueKey]) ? false : field.value)).includes(_.isBoolean(choice[primaryValueKey]) ? choice[primaryValueKey] : choice[primaryLabelKey])
  const doFilter = ( items ) => {
    if((filter || field.value) && DO_FILTER_MODES.includes(display_as)){
      const lFilter = filter.toLowerCase()
      return items.filter( item =>
          item[primaryLabelKey].toLowerCase().includes(lFilter)
          && multiple ? !choiceHas(item) : true

      )
    }
    return items
  }
  const processOptions = (parent_mapping_options, parentValued) => {
    let items = parentValued ? parent_mapping_options : choices;
    if(isRecordMode && ! parentValued){
      items = getRecord(records,records)
    }else{
      items = allow_create ? items.concat(customOptions) : items
    }
    return doFilter( items )
  }


  const basicOnChange = e => { helpers.setValue( isRecordMode ? getRecord(e.value,records) : e.value ) }

  const renderInPlaceCustom = () => {
    return !isRecordMode && allow_create ? <InplaceCustomOption optionValue={filter} addCustomOption={(customOption) => updateCustomOptions(customOption)}
      customLabel={create_label} customBtnLabel={extraConfig.create_button_label || 'ADD'}/> : <></>
  }
  const numCols = extraConfig['numCols'] || 3

  let optionChunks = _.chunk( options, Math.ceil(options.length / numCols ) )

  let comp = null
  if(display_as === 'dropdown' && !multiple){
    console.log('Displaying Dropdown', options, primaryValueKey, primaryLabelKey, toVal(), isRecordMode, optionDef('value'), optionDef('select'))
    comp = (
        <>
          <Dropdown onFilter={onFilterChange} disabled={disabled} options={options} optionValue={primaryValueKey} optionLabel={primaryLabelKey} valueTemplate={isRecordMode ? undefined : (as_chip ? toChip(use_color,options, optionDef('value')) : choiceLabel)} itemTemplate={isRecordMode ? undefined : (as_chip ? toChip(use_color, options, optionDef('select')) : choiceLabel)}
                    {...extract({
            scrollHeight: undefined, filter: true, filterBy: primaryLabelKey, filterMatchMode: undefined, filterPlaceholder: 'Search...',
            filterLocale: undefined, emptyMessage: undefined, emptyFilterMessage: undefined, resetFilterOnHide: undefined, editable: undefined,
            filterInputAutoFocus: undefined, showFilterClear: undefined, showClear: true, maxLength: undefined, dropdownIcon: undefined,

          }, extraConfig,restProps)} value={toVal()} />
          {renderInPlaceCustom()}
        </>
    )
  }else if(display_as === 'multiselect' && multiple){
    comp = (
        <>
          <MultiSelect onFilter={onFilterChange} disabled={disabled} options={options}  optionValue={primaryValueKey} optionLabel={primaryLabelKey} selectedItemTemplate={as_chip ? toChip(use_color, options, optionDef('value')) : choiceLabel} itemTemplate={isRecordMode ? undefined : (as_chip ? toChip(use_color, options, optionDef('select')) : choiceLabel)} {...extract({
            scrollHeight: undefined, filter: true, filterBy: primaryLabelKey, filterMatchMode: undefined, filterPlaceholder: 'Search...',
            filterLocale: undefined, emptyMessage: undefined, emptyFilterMessage: undefined, resetFilterOnHide: undefined, editable: undefined,
            filterInputAutoFocus: undefined, showFilterClear: undefined, showClear: true, maxLength: undefined, dropdownIcon: undefined,
            fixedPlaceholder: undefined, maxSelectedLabels: undefined, selectionLimit: undefined, selectedItemsLabel: undefined, display: 'chip', removeIcon: undefined,
            showSelectAll: undefined, selectAll: undefined,  optionDisabled: option => {
              return option.disabled
            }
          }, extraConfig,restProps)}
           onChange={ basicOnChange }
           value={toVal()}/>
          {renderInPlaceCustom()}
        </>
    )
  }else if(display_as === 'listbox'){
    comp = <>
      <div style={{width: '100%', display: 'flex', flexWrap: 'wrap' }}>
        <ListBox multiple={multiple} disabled={disabled} options={options} style={{width: '100%'}} filterInputProps={{style: {width: '100%'}}} filterValue={filter} onFilterValueChange={onFilterChange} optionValue={primaryValueKey} optionLabel={primaryLabelKey} itemTemplate={as_chip ? toChip(use_color, options, optionDef('value')) : choiceLabel}
        {...extract({
          filter: false, filterBy: primaryLabelKey, filterMatchMode: undefined, filterPlaceholder: 'Search...', listStyle: { maxHeight: '150px'},
          filterLocale: undefined,

        }, extraConfig,restProps)}
         onChange={ basicOnChange }
         value={toVal()}
        />
        {renderInPlaceCustom()}
      </div>
    </>
  }else if(display_as === 'buttons'){
    comp = <>
      <div style={{width: '100%', display: 'flex', flexWrap: 'wrap' }}>
        <SelectButton multiple={multiple} disabled={disabled} options={options} style={{width: '100%'}} optionValue={primaryValueKey} optionLabel={primaryLabelKey} {...extract({
          unselectable:undefined,

        }, extraConfig,restProps)} onChange={ basicOnChange } value={toVal()}
        />
        {renderInPlaceCustom()}
      </div>
    </>
  }else if(display_as === 'autocomplete'){

    comp = <>
      <div style={{width: '100%', display: 'flex', flexWrap: 'wrap' }}>
        <AutoComplete multiple={multiple} suggestions={options} disabled={disabled} style={{width: '100%'}}  {...extract({
          field: 'name', forceSelection: true, autoHighlight: undefined, scrollHeight: undefined,
          dropdown: true, dropdownMode: undefined, dropdownAutoFocus: undefined, minLength: undefined, delay: undefined,
          maxLength: undefined, size: undefined, dropdownIcon: undefined, removeIcon: undefined,

        }, extraConfig,restProps)}
        value={toVal()}
        completeMethod={onAutoComplete}
        onChange={ e => {
          const convertEntry = item => {
            if(_.isArray(item)) _.each(item, (val,key) => item[key] = convertEntry(val) )
            else if( _.isObject(item as any) )item = item[primaryValueKey]
            return isRecordMode ? getRecord(item) : item
          }
          const newVal = convertEntry( e.value )
          // let newVal = e.value
          // if(multiple){
          //   newVal = [...(field.value || [])]
          //   newVal.push(e.value)
          // }
          if(!multiple || newVal !== null)helpers.setValue( newVal )
        }}
        />
        {renderInPlaceCustom()}

      </div>
    </>
  }else if(display_as === 'radio' && !multiple){
    console.log('[RADIO]', {name:restProps.name, choices: extraConfig.choices, options,optionChunks})
    comp = <div className={'flex flex-wrap column-gap-4'} style={{width: '100%' }}>{optionChunks.map( (oc, ocIndex) =>
        <div key={`${restProps.name}_col_${ocIndex}`} className={'flex'} style={{flexDirection: 'column'}}>
          {oc.map( (choice:any, index) =>
              <div key={`${restProps.name}_${ocIndex}_${index}`}>
              <div className="field-radiobutton" >
            <RadioButton inputId={`${restProps.name}_${ocIndex}_${index}_input`} disabled={disabled} name={restProps.name} value={_.isBoolean(choice[primaryValueKey]) ? choice[primaryValueKey] : choice[primaryLabelKey]} checked={choiceHas(choice)} onChange={(e) =>{
              console.log('[SETTING RADIO]', {value:e.value,choice})
              helpers.setValue( isRecordMode ? getRecord(e.value) : e.value )
            }}/>
            <label htmlFor={choice[primaryLabelKey]}>{choice[primaryLabelKey]}</label>
          </div>
          <div style={{flexBasis: '100%', height: 0}}/>
              </div>
    )}
        </div>)}
      {renderInPlaceCustom()}
    </div>
  }else if(display_as === 'checkbox'){

    comp = <div className={'flex flex-wrap column-gap-4'} style={{width: '100%' }}>{optionChunks.map( (oc, ocIndex) =>
        <div key={`${restProps.name}_col_${ocIndex}`} className={'flex'} style={{flexDirection: 'column'}}>
          {oc.map( (choice:any, index) =>
              <div key={`${restProps.name}_${ocIndex}_${index}`}  >
          <>

            <Checkbox inputId={choice[primaryValueKey]} disabled={disabled} value={choiceVal(choice)} checked={choiceHas(choice)} onChange={ (e) => {
              if(multiple) {
                const newValue = [...wrapArray(field.value)]
                if (e.checked) {
                  newValue.push(isRecordMode ? getRecord(`${e.value}`) : `${e.value}`)
                } else {
                  newValue.splice(valueIndexOf(e.value), 1)
                }
                helpers.setValue(newValue)
              }else{
                if (e.checked) {
                  helpers.setValue(isRecordMode ? getRecord(e.value) : e.value)
                }else{
                  helpers.setValue(null)
                }
              }
            }}/>
            <label htmlFor={choice[primaryLabelKey]}  className="p-checkbox-label">  {choice[primaryLabelKey]}</label>
          </>
          <div style={{flexBasis: '100%', height: 0}}/>

        </div>
    )}
        </div>)}
      {renderInPlaceCustom()}
    </div>
  }else if(display_as === 'picklist' && multiple){
    comp = (
        <>
          <PickList choiceLabelKey={primaryLabelKey} choiceValueKey={primaryValueKey} onChange={(newValues) => helpers.setValue(newValues)} value={field.value} choices={options} extraConfig={extraConfig}/>
          {renderInPlaceCustom()}
        </>
    )
  }

  return compOnly ? comp : wrapComponent( comp, extraConfig)
};

export default React.memo(BaseSelect);
